import { useEffect, useCallback, useState } from 'react';

export const useTextHighligher = (search: string) => {
  const [currentElement, setCurrentElement] = useState<HTMLElement>();

  const nodeRef = useCallback((node) => {
    if (node !== null) {
      setCurrentElement(node);
    }
  }, []);

  useEffect(() => {
    // highlight all occurences of text matching the search term
    if (!search || !currentElement) {
      return;
    }

    const regex = new RegExp(search, 'gi');

    currentElement.innerHTML = currentElement.innerHTML.replace(
      regex,
      (match) => `<span style="background-color: yellow">${match}</span>`
    );
  }, [currentElement, search]);

  return nodeRef;
};
